var map = {
	"./add.svg": "3Fcy",
	"./arrow-bottom.svg": "OPxU",
	"./arrow-top.svg": "NOvd",
	"./eyes.svg": "z1HN",
	"./f2.svg": "4eLW",
	"./openEyes.svg": "GIZI",
	"./options.svg": "Q2GI",
	"./symbol.svg": "tCqH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DR8y";


//////////////////
// WEBPACK FOOTER
// ./src/svg \.svg$
// module id = DR8y
// module chunks = 317